import ReactMarkdown from "react-markdown";
import { alpha, Box, Stack, Typography } from "@mui/material";

/**
 * Shared markdown renderer for the /kayttoehdot and /tietosuoja pages — MUI
 * Typography variants matching the page rhythm. h1 is suppressed (the page owns
 * its own title). Previously duplicated as MarkdownBody (Kayttoehdot) and inline
 * (Tietosuoja).
 */
export default function LegalMarkdown({ markdown }) {
    return (
        <ReactMarkdown
            components={{
                h1: () => null,
                h2: ({ children }) => (
                    <Typography variant="h5" component="h2" sx={{ fontWeight: 600, mt: 4, mb: 1.5 }}>
                        {children}
                    </Typography>
                ),
                h3: ({ children }) => (
                    <Typography variant="h6" component="h3" sx={{ fontWeight: 600, mt: 3, mb: 1 }}>
                        {children}
                    </Typography>
                ),
                p: ({ children }) => (
                    <Typography variant="body1" sx={{ lineHeight: 1.7, mb: 1.5 }}>
                        {children}
                    </Typography>
                ),
                ul: ({ children }) => (
                    <Stack component="ul" spacing={0.5} sx={{ pl: 3, mb: 1.5 }}>{children}</Stack>
                ),
                li: ({ children }) => (
                    <Typography component="li" variant="body1" sx={{ lineHeight: 1.7 }}>
                        {children}
                    </Typography>
                ),
                // The English documents open with a blockquote saying they are an
                // unofficial translation and the Finnish text is the binding one —
                // the single most important sentence on the page to not read as
                // body copy. Without an override react-markdown emits a bare
                // <blockquote> with no callout treatment at all.
                blockquote: ({ children }) => (
                    <Box
                        component="blockquote"
                        sx={{
                            my: 3,
                            mx: 0,
                            px: 2,
                            py: 1.5,
                            borderLeft: 3,
                            borderColor: "warning.main",
                            borderRadius: 1,
                            bgcolor: (t) => alpha(t.palette.warning.main, 0.08),
                            "& > :last-child": { mb: 0 },
                        }}
                    >
                        {children}
                    </Box>
                ),
            }}
        >
            {markdown || ""}
        </ReactMarkdown>
    );
}
